var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block space-y-1",on:{"click":_vm.showProjectTaskModal}},[_c('div',{staticClass:"text-gray-800",domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('span',{staticClass:"text-xs inline-block text-gray-600"},[_vm._v(" "+_vm._s(_vm.createdAt)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }